/**
 * CR150: Preview Source Toggle Component
 * 
 * Segmented control for switching between Draft / Published (Staging) / Published (Live)
 */

import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { FileEdit, Eye, Globe } from "lucide-react";
import type { PreviewSource } from "@/hooks/useLayoutPreviewSource";

interface PreviewSourceToggleProps {
  value: PreviewSource;
  onChange: (source: PreviewSource) => void;
  disabled?: boolean;
}

export function PreviewSourceToggle({ value, onChange, disabled }: PreviewSourceToggleProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-[10px] text-muted-foreground font-medium uppercase tracking-wide">
        Preview source
      </span>
      <ToggleGroup
        type="single"
        value={value}
        onValueChange={(v) => v && onChange(v as PreviewSource)}
        disabled={disabled}
      >
        <ToggleGroupItem 
          value="draft" 
          size="sm" 
          className="h-7 px-2 text-xs gap-1"
          title="Preview draft changes"
        >
          <FileEdit className="h-3 w-3" />
          Draft
        </ToggleGroupItem>
        <ToggleGroupItem 
          value="published_staging" 
          size="sm" 
          className="h-7 px-2 text-xs gap-1"
          title="Preview published staging layout"
        >
          <Eye className="h-3 w-3" />
          Staging
        </ToggleGroupItem>
        <ToggleGroupItem 
          value="published_live" 
          size="sm" 
          className="h-7 px-2 text-xs gap-1"
          title="Preview published live layout"
        >
          <Globe className="h-3 w-3" />
          Live
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
}
